import { Button } from "@constellation-academy/epic-ui";
import { DefaultTextFieldComponent, Form } from "@constellation-academy/framework-react-components";
import { useFormik } from "formik";
import React from "react";
import * as Yup from "yup";
import { useTranslation } from "@i18n/hooks";
import { type SendEmailFormProps, type SendEmailFormState } from "./send-email-form.types";
import { ValidatedField } from "../../../../components/ValidatedField";

export const SendEmailForm = ({ onSubmit }: SendEmailFormProps) => {
	const { t } = useTranslation(["common", "validation"]);
	const formik = useFormik<SendEmailFormState>({
		initialValues: {},
		validationSchema: Yup.object().shape({
			email: Yup.string()
				.email(t("validation:emailInvalid"))
				.required(t("validation:emailRequired")),
		}),
		onSubmit,
	});

	const handleOnClick = () => {
		formik.handleSubmit();
	};

	return (
		<Form onSubmit={formik.handleSubmit}>
			<ValidatedField<SendEmailFormState, string>
				name={"email"}
				label={t("common:table.email")}
				required
				formikConfig={formik}
				component={DefaultTextFieldComponent}
			/>
			<Button
				label={t("common:emailTemplates.send")}
				disabled={!formik.isValid}
				onClick={handleOnClick}
			/>
		</Form>
	);
};
